// ----------------------------------------------------------------------------
// Snippet: Smart Cart Template
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import './_smart-cart-template.scss';

// Scripts
import $ from 'jquery';


$(function() {
    document.addEventListener('rebuy:smartcart.ready', function(event) {    
        //This event is triggered whenever SmartCart slider is opened or updated.
        document.addEventListener('rebuy:cart.change', function(event){
            // Update MiniCart when product is added via Rebuy SmartCart
            Shopify.miniCart.init();
        });
    });

});